import { beaconAssert } from "./assertions.js";
export class CommerceApiWrapper {
    relay;
    options;
    constructor(relay, options) {
        this.relay = relay;
        this.options = options;
    }
    async emitSearch(data) {
        const clientId = this.relay.getMeta("ec.productView").clientId;
        beaconAssert(clientId != null);
        const source = this.relay.getMeta("ec.productView").source;
        const body = {
            trackingId: this.options.trackingId,
            language: this.options.language,
            country: this.options.country,
            currency: this.options.currency,
            clientId,
            query: data.query || "",
            context: {
                user: {
                    userAgent: navigator.userAgent,
                },
                view: {
                    url: window.location.href,
                    referrer: document.referrer,
                },
                source: Array.isArray(source) ? source : [source],
                capture: true,
                non_coveo_result_count: data.numberOfResults || 0,
                non_coveo_result_list: data.products || null,
                poc_origin: "raptor",
            },
        };
        const resp = await fetch(`${this.options.platformEndpoint}/rest/organizations/${this.options.organizationId}/commerce/v2/search`, {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.options.searchApiKey}`,
                accept: "*/*",
            },
        });
        const responseData = await resp.json();
        if (!resp.ok) {
            throw new Error(`Failed to send analytics event through Commerce Search API:\nSent: ${JSON.stringify(body)}\nGot: ${JSON.stringify(responseData)}`);
        }
        const searchUid = responseData.responseId;
        beaconAssert(searchUid != null);
        return searchUid;
    }
    async emitListing(data) {
        const clientId = this.relay.getMeta("ec.productView").clientId;
        beaconAssert(clientId != null);
        const source = this.relay.getMeta("ec.productView").source;
        const body = {
            trackingId: this.options.trackingId,
            language: this.options.language,
            country: this.options.country,
            currency: this.options.currency,
            clientId,
            context: {
                user: {
                    userAgent: navigator.userAgent,
                },
                source: Array.isArray(source) ? source : [source],
                view: {
                    url: window.location.href,
                    referrer: document.referrer,
                },
                capture: true,
                non_coveo_result_count: data.numberOfResults || 0,
                non_coveo_result_list: data.products || null,
                poc_origin: "raptor",
            },
        };
        const resp = await fetch(`${this.options.platformEndpoint}/rest/organizations/${this.options.organizationId}/commerce/v2/listing`, {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.options.searchApiKey}`,
                accept: "*/*",
            },
        });
        const responseData = await resp.json();
        if (!resp.ok) {
            throw new Error(`Failed to send analytics event through Commerce Listing API:\nSent: ${JSON.stringify(body)}\nGot: ${JSON.stringify(responseData)}`);
        }
        const listingId = responseData.responseId;
        beaconAssert(listingId != null);
        return listingId;
    }
}
//# sourceMappingURL=commerce-api-wrapper.js.map